<template>
  <div class="custom_map" id="allmap" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: "JiayuSmartMap",

  data() {
    return {
      mapData: {
        one_first_1: [
          [113.26361, 23.154844],
          [113.263632, 23.155574],
          [113.263557, 23.156166],
          [113.263482, 23.156995],
          [113.26346, 23.157073],
          [113.263557, 23.157863],
          [113.263653, 23.158168],
          [113.263696, 23.158474],
        ],
        two_second_1: [
          [113.26272, 23.151352],
          [113.262945, 23.152486],
          [113.263546, 23.154321],
          [113.26361, 23.154844],
        ],
        three_three_1: [
          [113.267671, 23.153764],
          [113.267548, 23.153749],
          [113.267387, 23.153784],
          [113.266931, 23.153823],
          [113.266577, 23.153863],
          [113.266185, 23.153912],
          [113.265552, 23.153971],
          [113.265214, 23.154006],
          [113.264458, 23.154075],
          [113.263616, 23.154154],
          [113.26361, 23.154282],
          [113.263685, 23.154898],
          [113.26368, 23.155091],
        ],
        four_fouth_1: [
          [113.269651, 23.158188],
          [113.269141, 23.157157],
          [113.268857, 23.156472],
          [113.268481, 23.155609],
          [113.268358, 23.155337],
          [113.26817, 23.154888],
          [113.268063, 23.154647],
          [113.267762, 23.153932],
          [113.267671, 23.153764],
        ],
        data_first_2: [
          [113.270423, 23.156795],
          [113.271163, 23.156839],
          [113.27171, 23.156854],
          [113.272558, 23.157007],
        ],
        data_first_3: [
          [113.263193, 23.153651],
          [113.263127, 23.153472],
          [113.263056, 23.153401],
          [113.262979, 23.153344],
          [113.262896, 23.153311],
          [113.262826, 23.153313],
          [113.262731, 23.153328],
          [113.262607, 23.153425],
        ],
        data_first_4: [
          [113.262421, 23.153252],
          [113.262529, 23.152974],
          [113.262582, 23.152765],
          [113.262592, 23.15267],
          [113.262592, 23.15267],
          [113.26263, 23.152329],
        ],
        data_first_5: [
          [113.261399, 23.142043],
          [113.261335, 23.141264],
          [113.261254, 23.140588],
          [113.260938, 23.140302],
        ],
        data_second_2: [
          [113.265315, 23.168689],
          [113.265458, 23.168607],
          [113.265549, 23.168432],
          [113.265576, 23.168259],
          [113.265573, 23.168245],
          [113.265524, 23.16815],
          [113.265429, 23.16798],
        ],
        data_second_3: [
          [113.271032, 23.177845],
          [113.270083, 23.176302],
          [113.269755, 23.176198],
          [113.269144, 23.176306],
          [113.268564, 23.176573],
        ],
        data_second_4: [
          [113.263944, 23.179073],
          [113.263606, 23.179813],
          [113.263284, 23.179926],
          [113.262131, 23.181065],
          [113.261439, 23.181475],
        ],
        data_first_6: [
          [113.272936, 23.16477],
          [113.272475, 23.164928],
          [113.272078, 23.164997],
          [113.271675, 23.165115],
          [113.27093, 23.165293],
          [113.268097, 23.166018],
        ],
        data_first_7: [
          [113.269422, 23.169884],
          [113.268864, 23.169125],
          [113.268516, 23.168666],
          [113.267695, 23.167537],
        ],

        data_first_8: [
          [113.266896, 23.163276],
          [113.2671, 23.163789],
          [113.267223, 23.164306],
          [113.267427, 23.164913],
          [113.267427, 23.164913],
          [113.267427, 23.164913],
          [113.267695, 23.167034],
          [113.267631, 23.167453],
        ],

        data_first_9: [
          [113.261521, 23.169036],
          [113.262465, 23.168425],
          [113.263441, 23.167981],
          [113.26439, 23.167532],
        ],
        data_first_10: [
          [113.26552, 23.175204],
          [113.266776, 23.174603],
          [113.267392, 23.174302],
        ],

        data_first_11: [
          [113.273857, 23.174026],
          [113.2745, 23.173922],
        ],

        data_first_12: [
          [113.27398, 23.169548],
          [113.272258, 23.170006],
          [113.271485, 23.17013],
        ],
      },
      nameArr: [],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.map = new AMap.Map("allmap", {
        resizeEnable: true,
        zoom: 11, //级别
        center: [113.227411, 23.810424], //中心点坐标
        // mapStyle: "amap://styles/blue",
        mapStyle: "amap://styles/darkblue", //设置地图的显示样式
      });
      this.setPolyline(this.mapData); // 根据数据配置轨迹参数
    },
    setPolyline(obj) {
      let objKeyArr = Object.keys(obj);
      console.log(objKeyArr, "objKeyArr"); //['1_alarm_1', '2_normal_1', '3_alarm_2', '4_normal_2', '5_alarm_3', '6_over_1']
      // 设置地图的中心点

      // return
      // let centerLnglat = obj[objKeyArr[0]][0];
      let centerLnglat = [113.267411, 23.130424];
      this.map.setZoomAndCenter(14, centerLnglat, true);
      // 绘画轨迹
      let lineArr = []; // 存储轨迹的一维数组
      for (let i in obj) {
        console.log(i, "jsjddjjs");
        let color = ""; // 定义轨迹的颜色变量
        let name = "polyline" + i; // 定义动态的轨迹变量名
        let type = i.split("_"); // 获取轨迹的类型
        if (type[1] == "first") {
          // 根据轨迹的类型进行颜色的赋值
          color = "red";
        } else if (type[1] == "second") {
          color = "orange";
        } else if (type[1] == "three") {
          color = "skyblue";
        } else if (type[1] == "fouth") {
          color = "green";
        }
        // 配置轨迹
        name = new AMap.Polyline({
          map: this.map,
          path: obj[i], // 轨迹的坐标数组
          showDir: true,
          strokeColor: color,
          strokeWeight: 6, //线宽
          lineJoin: "round",
        });
        console.log(name, "111");
        this.nameArr.push(name);
        // 拼接轨迹的一维数组（用于运行轨迹动画）
        lineArr = lineArr.concat(obj[i]);
      }
      console.log("nameArr", this.nameArr);
      this.markerPolyline = new AMap.Marker({
        map: this.map,
        position: centerLnglat,
        // icon: "https://webapi.amap.com/images/car.png",
        offset: new AMap.Pixel(-50, -13),
        autoRotation: true,
        angle: -90,
      });
      // this.markerPolyline.moveAlong(lineArr, 200); // 自动加载动画
    },
  },
};
</script>
<style>
.amap-icon {
  display: none;
}
</style>
<style lang="scss" scoped>
</style>